// src/utils/phoneUtils.js

// Format phone number to ensure it starts with +254
export const formatKenyanPhone = (phone) => {
  if (!phone) return '';
  
  // Remove all non-digit characters
  const digits = phone.replace(/\D/g, '');
  
  // If empty after cleaning, return empty
  if (!digits) return '';
  
  // Handle different cases
  if (digits.startsWith('254')) {
    return `+${digits}`;
  } else if (digits.startsWith('0')) {
    return `+254${digits.substring(1)}`;
  } else if (digits.length <= 9) {
    // Assume it's the 9-digit number without prefix
    return `+254${digits}`;
  } else {
    // Any other case, just add the + prefix
    return `+${digits}`;
  }
};

// Validate Kenyan phone number
export const isValidKenyanPhone = (phone) => {
  if (!phone) return true; // Empty is valid (optional field)
  
  // Must start with +254 and followed by 9 digits
  const pattern = /^\+254\d{9}$/;
  return pattern.test(phone);
};

// Mask phone number to show only prefix and last 3 digits
export const maskPhoneNumber = (phone) => {
  if (!phone || typeof phone !== 'string') return '';
  
  const cleanedPhone = phone.replace(/\D/g, ''); // Remove non-digits

  if (cleanedPhone.length > 6) {
    const prefix = cleanedPhone.slice(0, cleanedPhone.length - 6); // Country code + area code part
    const lastThree = cleanedPhone.slice(-3);
    const maskedPart = 'x'.repeat(cleanedPhone.length - prefix.length - 3); // Mask the middle digits
    return `+${prefix}${maskedPart}${lastThree}`;
  } else if (cleanedPhone.length > 3) {
    // If too short to mask meaningfully but has more than 3 digits
    const firstPart = cleanedPhone.slice(0, cleanedPhone.length - 3);
    const lastThree = cleanedPhone.slice(-3);
    return `+${firstPart}xxx${lastThree}`; // Generic masking with last 3 digits
  }
  return `+${cleanedPhone}`; // Return as is if very short
}; 